<template>
  <!-- Login Component -->
  <v-container>
    <parameter ref="param" @error="onError" @id="onId"></parameter>
  </v-container>
</template>

<script>
import paramCtrl from "@/components/controls/parameter";
import settingsService from "@/_services/settings-service";

export default {
  name: "Account-Login",

  components: {
    "parameter": paramCtrl,
  },

  mounted() {
    const data = {
      cancelUrl: settingsService.get("cancelUrl"),
      returnUrl: settingsService.get("loginUrl"),
      process: "login",
    };
    this.$refs.param.create(data);
  },

  methods: {
    onId(id) {
      window.location.href = settingsService.get("remoteLoginUrl") + id; 
    },

    onError(error) {
      console.log(error);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  margin-right: 15px;
}
.v-btn {
  margin-bottom: 20px;
  margin-left: 10px;
}
</style>
